import React, { useState } from 'react';
import './ProductShowcase.css';
import { getProductById } from '../data/products';
import FichaTecnica from './FichaTecnica';

const SHOWCASE_IDS = ['BA50', 'BH600', 'RBH130', 'BM20'];

function ProductShowcase() {
  const [productoModal, setProductoModal] = useState(null);
  const products = SHOWCASE_IDS.map(id => getProductById(id)).filter(Boolean);

  return (
    <section className="product-showcase-section" id="product-showcase-section">
      {productoModal && (
        <FichaTecnica
          producto={productoModal}
          onClose={() => setProductoModal(null)}
        />
      )}
      <div className="container">
        <h2>Nuestros productos</h2>
        <div className="product-cards">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onVerFicha={() => setProductoModal(product)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductCard({ product, onVerFicha }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="product-card">
      <div className="product-image-wrapper">
        {!imgError ? (
          <img
            src={product.imagen}
            alt={product.nombre}
            className="product-image"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="product-image-placeholder">
            <span>{product.modelo}</span>
          </div>
        )}
      </div>
      <div className="product-info">
        <span className="product-modelo-label">{product.modelo}</span>
        <h3>{product.nombre}</h3>
        <button
          className="btn primary"
          onClick={product.ficha ? onVerFicha : undefined}
          disabled={!product.ficha}
        >
          Ver ficha técnica
        </button>
      </div>
    </div>
  );
}

export default ProductShowcase;
